var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveIndicationText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "3.5 2 33 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Live-Indication-Text_svg__filter0_d_505_1752)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 33,
    height: 17,
    rx: 1,
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01 15V6.273h1.846v7.206h3.741V15H8.01zm8.654-8.727V15H14.82V6.273h1.845zm3.095 0l2.11 6.63h.08l2.114-6.63h2.046L23.1 15h-2.378L17.71 6.273h2.05zM27.16 15V6.273h5.88v1.521h-4.035v2.08h3.733v1.52h-3.733v2.085h4.053V15h-5.898z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Live-Indication-Text_svg__filter0_d_505_1752",
    x: 0,
    y: 0,
    width: 41,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_505_1752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_505_1752",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/svg/ggbet/Live-Indication-Text.svg";
export { SvgLiveIndicationText as ReactComponent };